<template>
  <v-layout>
    <v-col v-if="Gift.isForm" cols :sm="12" class="pa-0">
      <v-form v-model="Gift.isValid" ref="form">
        <v-card flat class="pt-5">
          <v-layout align-center class="px-3">
            <h2>{{ $t("menu.gift") }}</h2>
            <v-spacer></v-spacer>
            <v-icon @click="_fnReset()" color="primary"> mdi-close </v-icon>
          </v-layout>
          <v-card-text>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-upload
                  :width="450"
                  :height="250"
                  class="mb-3"
                  :label="$t(`table.image`)"
                  v-model="Gift.obj.image"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Gift.obj.titleVI"
                >
                  <template #label>
                    {{ $t(`table.title`) + " (VI)" }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-text-field
                  color="primary"
                  :rules="[Rules.required]"
                  v-model="Gift.obj.titleEN"
                >
                  <template #label>
                    {{ $t(`table.title`) + " (EN)" }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="3" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Gift.obj.price"
                >
                  <template #label>
                    {{ $t(`table.price`) }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="3" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Gift.obj.promotion"
                >
                  <template #label>
                    {{ $t(`table.promotion`) }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="pt-3">
                <v-row>
                  <v-col cols :sm="2" class="pt-3">
                    <v-checkbox
                      color="primary"
                      :label="$t(`table.isHot`)"
                      hide-details
                      v-model="Gift.obj.isHot"
                    ></v-checkbox>
                  </v-col>
                  <v-col cols :sm="2" class="pt-3">
                    <v-checkbox
                      color="primary"
                      :label="$t(`table.isLimit`)"
                      hide-details
                      v-model="Gift.obj.isLimit"
                    ></v-checkbox>
                  </v-col>
                  <v-col v-if="Gift.obj.isLimit" cols :sm="8" class="py-0">
                    <v-datePickerRange
                      v-model="Gift.obj.dateRange"
                      :rules="[Rules.required]"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="3" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Gift.obj.amount"
                  :readonly="Gift.obj.type == '623bf70563678cdc29ed0166'"
                >
                  <template #label>
                    {{ $t(`table.amount`) }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="3" class="py-0">
                <v-text-field
                  color="primary"
                  type="number"
                  :rules="[Rules.required, Rules.number]"
                  v-model="Gift.obj.priority"
                >
                  <template #label>
                    {{ $t(`table.priority`) }}
                    <span class="red--text">
                      <strong>*</strong>
                    </span>
                  </template>
                </v-text-field>
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-typeSponsor
                  v-model="Gift.obj.sponsor"
                  :rules="[Rules.required]"
                />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-typeGift v-model="Gift.obj.type" :rules="[Rules.required]" />
              </v-col>
              <v-col cols :sm="6" class="py-0">
                <v-statusGift
                  v-model="Gift.obj.status"
                  :rules="[Rules.required]"
                />
              </v-col>
            </v-row>
            <v-row v-if="Gift.obj.type == '623bf70563678cdc29ed0166'">
              <v-col cols :sm="12" class="pt-0 pb-3">
                <v-card>
                  <v-data-table
                    :items="Gift.obj.vouchers"
                    :headers="cTableHeaders"
                    :items-per-page="5"
                    item-key="item.id"
                    :search="search"
                    dense
                  >
                    <template v-slot:top>
                      <v-layout pa-2 justify-space-around align-end>
                        <v-layout align-center>
                          <v-btn
                            small
                            class="mr-3"
                            color="primary"
                            @click="$refs.input.click()"
                          >
                            Import
                          </v-btn>
                          <input
                            :style="{ display: 'none' }"
                            type="file"
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            ref="input"
                            @change="_fnImport()"
                          />
                          <v-btn small color="primary" @click="_fnExport()">
                            Export
                          </v-btn>
                        </v-layout>
                        <v-spacer />
                        <div class="mb-3" :style="{ width: '220px' }">
                          <v-text-field
                            v-model="search"
                            :placeholder="$t(`table.search`)"
                            single-line
                            hide-details
                            dense
                            append-outer-icon=""
                          />
                        </div>
                      </v-layout>
                    </template>
                    <template #[`item.user.name`]="{ item }">
                      <span v-if="item.user">
                        {{ "LomoId: " + item.user.lomoId }}<br />
                        {{ "Name: " + item.user.name }}<br />
                      </span>
                    </template>
                    <template #[`item.date`]="{ item }">
                      <span v-if="item.date">{{ item.date | mDateTime }}</span>
                    </template>
                  </v-data-table>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-editor
                  :label="$t(`table.description`) + ' (VI)'"
                  v-model="Gift.obj.descriptionVI"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols :sm="12" class="py-0">
                <v-editor
                  :label="$t(`table.description`) + ' (EN)'"
                  v-model="Gift.obj.descriptionEN"
                />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              :disabled="!Gift.isValid"
              @click="Gift.isCreate ? _fnCreate() : _fnUpdate()"
              >{{ Gift.isCreate ? $t(`table.create`) : $t(`table.update`) }}
            </v-btn>
            <v-btn outlined color="primary" @click="_fnReset()">
              {{ $t(`table.cancel`) }}
            </v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-col>

    <v-dialog
      v-if="Gift.isDelete"
      v-model="Gift.isDelete"
      persistent
      scrollable
      max-width="500"
    >
      <v-card>
        <v-card-title dense class="headline primary" />
        <v-card-text class="pt-2">
          {{ $t(`table.deleteMess`) }}
          <b>{{ Gift.obj.title }}</b>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="_fnDelete()">
            {{ $t(`table.delete`) }}
          </v-btn>
          <v-btn outlined color="primary" @click="_fnReset()">
            {{ $t(`table.cancel`) }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import XLSX from "xlsx";

export default {
  data: () => ({
    model: "Gift",
    vouchers: "",
    search: "",
  }),
  created() {
    this.cTableHeaders = [
      {
        text: this.$t(`table.voucher`),
        value: "code",
        width: "130px",
      },
      {
        text: this.$t(`table.name`),
        value: "user.name",
        width: "130px",
      },
      {
        text: this.$t(`table.date`),
        value: "date",
        width: "130px",
      },
    ];
  },
  methods: {
    _fnReset() {
      if (this.$refs.form) this.$refs.form.reset();
      this.fnResetFlagView(this.model);
    },
    _fnReFresh() {
      this._fnReset();
      this[this.model].isRefresh = true;
    },
    async _fnCreate() {
      const { code } = await this.fnPost({
        url: `/v1/admin/gift`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnUpdate() {
      const { code } = await this.fnPut({
        url: `/v1/admin/gift/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    async _fnDelete() {
      const { code } = await this.fnDelete({
        url: `/v1/admin/gift/${this[this.model].obj.id}`,
        model: this.model,
      });
      if (code === 200) {
        this._fnReFresh();
      }
    },
    _fnExport() {
      const xlsxData = XLSX.utils.json_to_sheet(
        this[this.model].obj.vouchers.map((e) => ({
          code: e.code,
          name: e.user && e.user.name,
          date: e.date && this.$moment.unix(e.date).format("HH:mm DD/MM/YYYY"),
        }))
      );
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, xlsxData, "voucher");
      XLSX.writeFile(
        wb,
        `Voucher-${this.$moment().format("YYYYMMDDHHmmss")}.xlsx`
      );
    },
    _fnImport() {
      var reader = new FileReader();
      reader.readAsBinaryString(this.$refs.input.files[0]);
      reader.onload = () => {
        var fileData = reader.result;
        var wb = XLSX.read(fileData, { type: "binary" });
        wb.SheetNames.forEach((sheetName) => {
          var data = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
          if (!data.length || !data[0].Voucher) {
            this.fnNotificationView({
              type: "error",
              message:
                this.$i18n.locale == "en"
                  ? "File invalid"
                  : "Dữ liệu không hợp lệ",
            });
          }
          data
            .map((e) => e.Voucher.trim())
            .filter(Boolean)
            .forEach((code) => {
              this[this.model].obj.vouchers.unshift({
                code: code,
                isUse: false,
              });
              this[this.model].obj.voucherTemps.unshift({
                code: code,
                isUse: false,
              });
            });
          this[this.model].obj.amount = this[this.model].obj.vouchers.filter(
            (e) => !e.isUse
          ).length;
        });
      };
    },
  },
};
</script>
